import { memo } from 'react';
import { StyledHeader } from '../styled';
import WalletSection from '../WalletSection/WalletSection';
import AccountSection from '../AccountSection/AccountSection';
import LogoutSection from '../LogoutSection/LogoutSection';
import Logo from '../Logo/Logo';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

const StyledLogoContainer = styled.section`
  flex: 1;
`;

const StyledNavigationIcon = styled.section`
  display: none;
  @media (max-width: 600px) {
    width: 55px;
    height: 100%;
    margin: 0px;
    padding: 0px;
    border-right: 1px solid #e5e5e5;
    position: relative;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    color: #707070;
    transition: background-color 0.5s;
    font-size: 20px;
    &:hover {
      background-color: #e5e5e5;
    }
  }
`;

const StyledHeaderUserName = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 16px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;

  @media (max-width: 600px) {
    display: none;
  }
`;

const Header = memo(
  ({
    fullName,
    profilePhoto,
    onClickLogout,
    gstBuyerWallet,
    gstSellerWallet,
    nonGstBuyerWallet,
    nonGstSellerWallet,
    appData: { appLogo, appName },
    showNav,
    setShowNav,
  }) => {
    return (
      <StyledHeader>
        <StyledNavigationIcon onClick={setShowNav}>
          <FontAwesomeIcon icon={showNav ? faXmark : faBars} />
        </StyledNavigationIcon>
        {/* <StyledLogoContainer>
          <Logo
            appLogo={appLogo}
            appName={appName}
            style={{ width: '150px' }}
          />
        </StyledLogoContainer> */}
        <StyledLogoContainer>
          <img
            src="/dashboardlogo.png"   // public folder
            alt={appName}
            style={{ width: '150px', height: 'auto' }}
          />
        </StyledLogoContainer>

        <WalletSection
          gstBuyerWallet={gstBuyerWallet}
          gstSellerWallet={gstSellerWallet}
          nonGstBuyerWallet={nonGstBuyerWallet}
          nonGstSellerWallet={nonGstSellerWallet}
        />
        <AccountSection fullName={fullName} profilePhoto={profilePhoto} />
        <LogoutSection onClickLogout={onClickLogout} />
      </StyledHeader>
    );
  }
);

export default Header;
